import { useQuery } from '@tanstack/react-query'

export const queryStudioAds = (params) => {

    const query = useQuery({
        queryKey: ['get-studio-ads', params],
        queryFn: async () => {
            const { data } = await axios.get(route('studio.editor.api.ads.index'), {
                params
            });
            return data || [];
        },
    });

    return query;
}